const BUSINESS_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Carry the currently selected collaborator tenant to Edge Functions without
 * adding a custom CORS header. The value is navigation context only; every
 * function must verify the authenticated user's live grant server-side. */
export const collaboratorFunctionFetch: typeof fetch = (input, init) => {
  const rawUrl = input instanceof Request ? input.url : String(input);
  const url = new URL(rawUrl, window.location.origin);
  const businessId = localStorage.getItem("dibs_collab_active_business")?.trim();
  if (
    url.pathname.includes("/functions/v1/") &&
    businessId &&
    BUSINESS_ID_PATTERN.test(businessId)
  ) {
    url.searchParams.set("dibs_business_id", businessId);
  }
  if (input instanceof Request) {
    return fetch(new Request(url.toString(), input), init);
  }
  return fetch(url.toString(), init);
};
